module.exports = __webpack_public_path__ + "assets/images/config_purple.svg?69097c69a3c8105ffe78e087469122fa";


//////////////////
// WEBPACK FOOTER
// ./_source/images/icons/sessions/config_purple.svg
// module id = 621
// module chunks = 0